import { Save } from "assets/icons/Common";
import { DashboardContext } from "contexts/DashboardContext";
import { ModalsContext } from "contexts/ModalsContext";
import { useContext, useEffect, useState } from "react";

import { ModalDeleteWordList, ModalSaveName, WordsItemBox } from "./components";
import { MODAL_DELETE_WORD_LIST, MODAL_SAVE_WORD_LIST } from "./components/constatnts";
import { ActionButton, ActionButtons, EmptyText, Title, WordsListBox } from "./saveWordsList.style";
import { getIsEmptyValue } from "./utils";

interface SaveWordsListProps {
  settingName: string;
  updateSetting: (name: string, value: string) => void;
  value: string;
  onConvertData: (params?: any) => string;
  onValidation?: (params?: any) => boolean;
  isGroupMaker?: boolean;
}

export const SaveWordsList = (props: SaveWordsListProps) => {
  const { settingName, updateSetting, value, onConvertData, onValidation } = props;
  const { data } = useContext(DashboardContext);
  const modalsContext = useContext(ModalsContext);
  const [activeListId, setActiveListId] = useState("");

  useEffect(() => {
    if (data.saveWords) {
      const activeList = data.saveWords.find((word) => word.words === value);

      if (activeList) {
        setActiveListId(activeList.id);
      } else {
        setActiveListId("");
      }
    }
  }, [value, data.saveWords]);

  const handleOpenSaveModal = () => {
    modalsContext.openModal({
      name: MODAL_SAVE_WORD_LIST,
    });
  };

  const handleOpenDeleteModal = (id: string) => {
    modalsContext.openModal({
      name: MODAL_DELETE_WORD_LIST,
      id,
    });
  };

  const handleAcceptWordList = (id: string) => {
    const words = data.saveWords.find((savedWord) => savedWord.id === id);
    if (!words) {
      return;
    }

    const isEmptyValue = getIsEmptyValue(words.words);

    if (isEmptyValue) {
      const valueSettings = onConvertData({ value: words.words });

      setActiveListId(id);
      updateSetting(settingName, valueSettings);
    }
  };

  const isValid = getIsEmptyValue(value);

  return (
    <div>
      <Title>{`${props?.isGroupMaker ? "Save Students List" : "Save word list"}`}</Title>

      <ActionButtons>
        <ActionButton
          withShadow={false}
          Icon={Save}
          onClick={handleOpenSaveModal}
          title="Save Words List"
          disabled={!isValid}
        />
      </ActionButtons>

      <Title>{`${
        props?.isGroupMaker ? "Click to load a student list:" : "Click to load a word list:"
      }`}</Title>

      <WordsListBox>
        {data?.saveWords ? (
          data?.saveWords.map((word) => (
            <WordsItemBox
              key={word.id}
              word={word}
              activeListId={activeListId}
              onOpenDeleteModal={handleOpenDeleteModal}
              onAcceptWordList={handleAcceptWordList}
              onValidation={onValidation}
            />
          ))
        ) : (
          <EmptyText>You haven't saved word lists</EmptyText>
        )}
      </WordsListBox>

      <ModalSaveName words={value} />
      <ModalDeleteWordList />
    </div>
  );
};
